/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Earningsafterfee2Inputs */

const en_earningsafterfee2 = /** @type {(inputs: Earningsafterfee2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`after ${i?.fee} ticket fee`)
};

const de_earningsafterfee2 = /** @type {(inputs: Earningsafterfee2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nach ${i?.fee} Ticketgebühr`)
};

/**
* | output |
* | --- |
* | "after {fee} ticket fee" |
*
* @param {Earningsafterfee2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsafterfee2 = /** @type {((inputs: Earningsafterfee2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsafterfee2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsafterfee2(inputs)
	return de_earningsafterfee2(inputs)
});
export { earningsafterfee2 as "earningsAfterFee" }